module.exports = __webpack_public_path__ + "static/img/about7.f820f43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about7.png
// module id = 7XrM
// module chunks = 1